import React from 'react';
import {requiresSuperAdmin, requiresAdmin, requiresUser} from 'hocs/requiresUser';

export const RequiresUser = requiresUser(({children}) => children);
export const RequiresAdmin = requiresAdmin(({children}) => children);
export const RequiresSuperAdmin = requiresSuperAdmin(({children}) => children);
